export const RESERVATION_ROOM = '/reservation-room/' as const
export const ROOM_RESERVATION = '/room-reservation/' as const
export const RESERVATION_ROOM_ALL = `${RESERVATION_ROOM}all` as const
export const ROOM_RESERVATION_ALL = `${ROOM_RESERVATION}all` as const
export const RESERVATION_TIME_SLOT = '/slot/' as const
export const RESERVATION_TIME_SLOT_ALL = `${RESERVATION_TIME_SLOT}all` as const
